import { render } from "./UrinalysisPanelTestSelection.vue?vue&type=template&id=1545de08"
import script from "./UrinalysisPanelTestSelection.vue?vue&type=script&lang=js"
export * from "./UrinalysisPanelTestSelection.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/panels/testSelection/UrinalysisPanelTestSelection.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1545de08"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1545de08', __exports__)) {
    console.log('reload')
    api.reload('1545de08', __exports__)
  }
  
  module.hot.accept("./UrinalysisPanelTestSelection.vue?vue&type=template&id=1545de08", () => {
    console.log('re-render')
    api.rerender('1545de08', render)
  })

}


export default __exports__